export default __webpack_public_path__ + "b4ad7aa27bc79867c1c6b97a9cd0269a.png";